import { render } from "./IphoneButton.vue?vue&type=template&id=1a8245c4&scoped=true"
import script from "./IphoneButton.vue?vue&type=script&lang=js"
export * from "./IphoneButton.vue?vue&type=script&lang=js"

import "./IphoneButton.vue?vue&type=style&index=0&id=1a8245c4&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8245c4"]])

export default __exports__